import React, { useState, useEffect, useRef } from 'react'
import ScrollReveal from 'scrollreveal'
import { Player } from '@lordicon/react'
import talk from "../icons/doodle-black-26-consultation-hover-pinch.json"
import budget from "../icons/doodle-black-138-department-hover-pinch.json"
import furniture from "../icons/doodle-black-154-furniture-hover-pinch.json"
import styles from "./SecondScreen.module.css"
import IconTextComponent from '../components/can/Can'

const CustomTextTransition = ({ texts, interval = 3000, className = "" }) => {
const [currentIndex, setCurrentIndex] = useState(0)
const [isVisible, setIsVisible] = useState(true)

useEffect(() => {
const timer = setInterval(() => {
setIsVisible(false)
setTimeout(() => {
setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length)
setIsVisible(true)
}, 300)
}, interval)

return () => clearInterval(timer)


}, [texts.length, interval])

return (
<span
className={className}
style={{
opacity: isVisible ? 1 : 0,
transform: isVisible ? 'translateY(0)' : 'translateY(-10px)',
transition: 'opacity 0.6s ease-in-out, transform 0.6s ease-in-out',
display: 'inline-block',
minHeight: '1.2em'
}}
>
{texts[currentIndex]}
</span>
)
}

const SecondScreen = () => {
const parallaxRef = useRef(null)
const introRef = useRef(null)
const summaryRef = useRef(null)
const featureTextRefs = useRef([])

const QUESTIONS = [
"קניתם דירה חדשה מקבלן?",
"מתחילים שיפוץ בקרוב?",
"רוצים למכור את הנכס שלכם במחיר גבוה יותר?"
]

useEffect(() => {
const handleScroll = () => {
if (parallaxRef.current) {
const scrollPosition = window.scrollY
const translateY = scrollPosition * 0.4
parallaxRef.current.style.transform = `translateY(${translateY}px)`;
}
}

window.addEventListener('scroll', handleScroll)
return () => window.removeEventListener('scroll', handleScroll)


}, [])

useEffect(() => {
const sr = ScrollReveal({
distance: '40px',
duration: 1000,
delay: 100,
opacity: 0,
mobile: true,
reset: false,
viewFactor: 0.2
})

const timer = setTimeout(() => {
  if (introRef.current) {
    sr.reveal(introRef.current, {
      origin: 'bottom',
      distance: '20px',
      delay: 100
    })
  }

  featureTextRefs.current.forEach((textRef, index) => {
    if (textRef) {
      sr.reveal(textRef, {
        origin: 'bottom',
        distance: '40px',
        delay: 200 + index * 150,
        duration: 1200
      })
    }
  })

  if (summaryRef.current) {
    sr.reveal(summaryRef.current, {
      origin: 'bottom',
      distance: '30px',
      delay: 500,
      duration: 1000
    })
  }
}, 200)

return () => {
  clearTimeout(timer)
  sr.destroy()
}


}, [])

return (
<>
<div className={styles.container}>

    <div className={styles.parallaxContainer}>
      <div ref={parallaxRef} className={styles.parallaxImage}></div>
    </div>

    <div className={styles.introSection}>
      <div className={styles.introBox} ref={introRef}>
        <CustomTextTransition
          texts={QUESTIONS}
          interval={3000}
        />
      </div>
    </div>
<div className={styles.description}>
הבית שלנו הוא המקום שבו אנו מתחילים ומסיימים כל יום, הוא משפיע על התחושות שלנו, על השקט שלנו, על כל מה שקורה לנו ביומיום. ואם אתם כאן, כנראה שאתם מתכננים לעשות בו שינוי.
</div>

{/* <div className={styles.title}>
אז הגיע הזמן לקחת את החזון שלכם ולגרום לו לקרות
</div> */}

<div className={styles.description}>
 <strong>שינויים עושים הרבה רעש בלב </strong> במיוחד כשהם נוגעים למקום הכי אישי שלנו. 
הם מביאים איתם התרגשות,  <strong> אבל גם המון סימני שאלה.</strong>
</div>

<div className={styles.title}>
וכשהם לא מתוכננים נכון – הם הופכים לכאב ראש יקר.. ואתם מוצאים את עצמכם
</div>

<div className={styles.row}>

<IconTextComponent text="הולכים לאיבוד מכל הדעות של אנשי המקצוע השונים" icon={talk}/>
<IconTextComponent text="נתקלים בהמון הוצאות לא צפויות שגורמות לתקציב שלכם לטפס" icon={budget}/>
<IconTextComponent text="עושים טעויות קריטיות בריהוט שלא מתאים למידות הדירה" icon={furniture}/>

</div>
<div className={styles.description}>
ובעיקר.. לוחצים עליכם לקבל החלטות קריטיות בתהליך כל כך חשוב עוד לפני שתפסתם כיוון אמיתי וההתרגשות של התהליך מתחילה עם הזמן להתחלף בעצבים ומתחים. אז שנייה לפני שזה קורה 
</div>

<div className={styles.title}>
התפקיד שלי הוא לעשות לכם סדר בבלאגן
</div>

    {/* <div className={styles.description}>
      אז איך עושים את זה נכון
    </div>

    <div className={styles.description}>
      מתחילים בתכנון מסודר. מבינים את הצרכים. שמים גבולות לתקציב. צעד אחרי צעד. בלי בלגן.
    </div> */}

  </div>
</>


)
}

export default SecondScreen